import React from 'react';

import { Grid, Typography } from '@mui/material';
import PrimitiveInput from './base/PrimitiveInput';

const FirstName = () => (
  <Grid container spacing={10}>
    <Grid size={12}>
      <Typography
        color="#646464"
        variant="h6"
      >
        First name
      </Typography>
    </Grid>
    <PrimitiveInput />
  </Grid>
);

export default FirstName;
